export default {
    transformAncillarySErvice(group, valueKey, labelKey) {
        if (group.facilityServiceTypes) {
            return group.facilityServiceTypes.map((ip) => ({
                value: ip[valueKey],
                label: ip[labelKey],
                data: ip,
            }))
        }

        return [
            {
                value: group[valueKey],
                label: group[labelKey],
                data: group,
            },
        ]
    },

    transform(valueKey, labelKey) {
        return (data) =>
            JSON.parse(data).map((option) => ({
                heading: option.facilityServiceTypes ? option[labelKey] : null,
                value: option[valueKey],
                label: option[labelKey],
                options: this.transformAncillarySErvice(option, valueKey, labelKey),
            }))
    },
}
